import React from 'react';
import DNSChecker from './DNSChecker';
import DNSRecordGenerator from './DNSRecordGenerator';
import DomainSetupTester from './DomainSetupTester';
import SESVerification from './SESVerification';
import SESRealTimeChecker from './SESRealTimeChecker';
import EmailAddressDebugger from './EmailAddressDebugger';

const StandaloneDNSChecker: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900">Scubamail Domain Setup</h1>
          <p className="mt-2 text-gray-600">
            Configure and verify your DNS settings for scaledots.com
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* DNS Records */}
          <div className="bg-white rounded-lg shadow">
            <div className="px-6 py-4 border-b border-gray-200">
              <h2 className="text-lg font-medium text-gray-900">📋 DNS Records to Add</h2>
              <p className="text-sm text-gray-600">Copy these records to your DNS provider</p>
            </div>
            <div className="p-6">
              <DNSRecordGenerator />
            </div>
          </div>

          {/* DNS Checker */}
          <div className="bg-white rounded-lg shadow">
            <div className="px-6 py-4 border-b border-gray-200">
              <h2 className="text-lg font-medium text-gray-900">🔍 DNS Checker</h2>
              <p className="text-sm text-gray-600">Verify your DNS records are working</p>
            </div>
            <div className="p-6">
              <DNSChecker />
            </div>
          </div>
        </div>

        {/* AWS SES Real-Time Status */}
        <div className="mt-8">
          <SESRealTimeChecker />
        </div>

        {/* AWS SES Verification Guide */}
        <div className="mt-8">
          <SESVerification />
        </div>

        {/* Email Address Debugger */}
        <div className="mt-8">
          <EmailAddressDebugger />
        </div>

        {/* Test Setup */}
        <div className="mt-8">
          <div className="bg-white rounded-lg shadow">
            <div className="px-6 py-4 border-b border-gray-200">
              <h2 className="text-lg font-medium text-gray-900">🧪 Test Your Setup</h2>
              <p className="text-sm text-gray-600">Test email sending with your domain</p>
            </div>
            <div className="p-6">
              <DomainSetupTester userId="admin-user" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StandaloneDNSChecker;
